module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), (_vm.subTitle) ? _c('span', {
    staticClass: "subTitle"
  }, [_vm._v("查看详情")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37783270"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title/Title.vue
// module id = 505
// module chunks = 1